module.exports = __webpack_public_path__ + "media/react/assets/imgs/signup-f8136f15025b9de39a177755335da162.png";